'use client';

import { useState } from 'react';
import type { ReactNode } from 'react';

type FAQ = { q: string; a: ReactNode };

export default function FAQAccordion({ faqs }: { faqs: FAQ[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="gr-faq-list">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className={`gr-faq-item${isOpen ? ' gr-faq-item--open' : ''}`}>
            <button
              className="gr-faq-btn"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
            >
              <span className="gr-faq-num">0{i + 1}</span>
              <span className="gr-faq-q">{f.q}</span>
              <span className="gr-faq-icon" aria-hidden="true">
                {isOpen ? '−' : '+'}
              </span>
            </button>
            <div className="gr-faq-body" style={{ maxHeight: isOpen ? '300px' : '0' }}>
              <p className="gr-faq-a">{f.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
